/**
 * Visitor storage written by the widget before the product was named Kapia.
 *
 * A visitor who last saw the old bundle has their conversation, the side they
 * moved the window to and its size under these names; moving them across once
 * keeps all three instead of starting over.
 */
const LEGACY_KEYS = ['pleiground_chat_anchor', 'pleiground_chat_size'];
const LEGACY_CONVERSATION_PREFIX = 'pleiground_webchat_';

/**
 * Move every legacy widget key in `localStorage` onto its `kapia_` name, once.
 * A value already under the new name wins. Storage that cannot be read (a
 * sandboxed iframe, a privacy mode) is left alone.
 */
export function adoptLegacyVisitorStorage(): void {
  try {
    for (const legacyKey of Object.keys(localStorage)) {
      if (!LEGACY_KEYS.includes(legacyKey) && !legacyKey.startsWith(LEGACY_CONVERSATION_PREFIX)) continue;
      const key = `kapia_${legacyKey.slice('pleiground_'.length)}`;
      const value = localStorage.getItem(legacyKey);
      if (value !== null && localStorage.getItem(key) === null) localStorage.setItem(key, value);
      localStorage.removeItem(legacyKey);
    }
  } catch {
    // ignore storage access errors
  }
}
